export const disabledOpacity = 0.3;
